import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { ModalTypeList } from 'shared/ui/Modal/store/types.ts'
import { numberFormat } from 'shared/lib'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { BillingPath } from 'pages/settings/pages/billing/route/billingPath.ts'

export const showInsufficientCreditsModal = ({
  entities,
  creditsAmount,
  onClose,
}: {
  entities: IEntitiesStore
  creditsAmount: number
  onClose?: () => void
}) => {
  const id = nanoid()
  const creditsAmountString = numberFormat({
    value: creditsAmount,
  })
  const handleClose = () => {
    onClose?.()
    modalStore.removeModal(id)
  }
  if (entities.usersStore.user?.isAdminOrOwnerRole) {
    modalStore.addModal({
      id,
      type: ModalTypeList.WARNING,
      title: 'Insufficient credits',
      desc: `You need ${creditsAmountString} more credits to send the broadcast. Enable auto-recharge to keep messaging without interruptions`,
      onClose: handleClose,
      primaryAction: {
        text: 'Purchase credits',
        onAction: () => {
          window.open(`/${BillingPath.overview}`, '_blank')
          modalStore.closeModal(id)
        },
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => {
          modalStore.closeModal(id)
        },
      },
    })
  } else {
    modalStore.addModal({
      id,
      type: ModalTypeList.WARNING,
      title: 'Insufficient credits',
      onClose: handleClose,
      desc: `You need ${creditsAmountString} more credits to send the broadcast. Contact your admin to add credits.`,
      closeActionButtonProps: {
        text: 'Ok',
      },
    })
  }
}
